import parseFunction from '@ali/vu-function-parser';
import { isString } from '@ali/re-utils';
import proxyCreateContext from '../apiUpgrade/createContext';

function flow(...fnList) {
  let result = null;
  return function flowWrap(context, ...args) {
    fnList.forEach((f) => {
      // 兼容有或者没有 context 的情况
      if (context && context.ctx && !context.ctx.isContextInAction) {
        result = f.call(context, ...args, result);
      } else {
        result = f.call(context, context, ...args, result);
      }
    });
    return result;
  };
}

// 触发元件上的回调函数
function exec(scope, callbackName, ...params) {
  if (!callbackName || !isString(callbackName)) {
    console.error('should pass the parameter of the callback name. Instead we got', callbackName);
    return;
  }
  const props = scope.getOwner().getProps('events');
  let symbolEvents = props && props[callbackName];
  if (!symbolEvents) {
    return;
  }
  try {
    // 需要一个 global 的 actionContext
    let that = this;
    // 从 action
    symbolEvents = symbolEvents.map((s) => {
      if (s.func) {
        // 向前兼容func的方式
        return parseFunction(s.func);
      }
      if (s.type === 'actionRef') {
        // 升级前后，store 引用的 api 不同
        let context = this.store && this.store.getContext && this.store.getContext();
        if (!context && this.ctx) {
          context = this.ctx;
          that = context.getAction().getActionContext();
          if (that) {
            that.__syncState();
          }
        }
        const action = context && context.getAction() && context.getAction().getAction(s.id);
        if (action && action.func) {
          return action.func;
        }
      }
      return s;
    });
    flow(...symbolEvents)(that, ...params);
  } catch (e) {
    console.warn(e.message);
  }
}

export default function createContext(apis, xprops/* , ctx */) {
  const scope = xprops.getState().getOwnerScope();
  scope.setIteratorId(xprops.getIteratorId());
  scope.setIndex(xprops.getIndex());
  const store = xprops.getStore();
  let isContextInAction = true;
  if (store.context && store.context.isContextInAction === false) {
    isContextInAction = false;
  }
  const context = {
    ...apis,
    isContextInAction,
    params: apis.params || {},
    get state() {
      return xprops.getState();
    },
    scope,
    get form() {
      return xprops.getState().getOwnerForm();
    },
    store,
    get dp() {
      return apis.getDataPool();
    },
    __createByAction: true,
  };
  /**
   * 对于元件，添加 execAction API
   */
  const proxiedContext = proxyCreateContext(context);
  if (xprops.isSectionRendered()) {
    context.scope.execAction = exec.bind(proxiedContext, scope);
  }
  apis.setDynamicProps({
    params: context.params,
    state: context.state,
    scope: context.scope,
    form: context.form,
  });
  return { proxiedContext, context };
}
